import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { getaudio, playaudio } from '../../common/functions';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import './Buttons.css';
export function Morebuttons(props) {
    var _a = useState(0), counter = _a[0], setCounter = _a[1];
    useEffect(function () {
        function keyboardhadler(evt) {
            if (evt.code === 'ArrowLeft') {
                props.updatefunc(false, props.elems[counter]);
                if (counter === props.elems.length - 1)
                    props.endfunc();
                setCounter(counter + 1);
            }
            if (evt.code === 'ArrowRight') {
                props.updatefunc(true, props.elems[counter]);
                if (counter === props.elems.length - 1)
                    props.endfunc();
                setCounter(counter + 1);
            }
            if (evt.code === 'Space') {
                playaudio(getaudio(props.elems[counter].audio));
            }
        }
        document.addEventListener('keydown', keyboardhadler);
        return function () { return document.removeEventListener('keydown', keyboardhadler); };
    }, [counter, props]);
    return (React.createElement("div", { className: "Buttoncontainer" },
        React.createElement("div", { className: "wordText" },
            React.createElement("p", { className: "wordtext english_word" },
                " ",
                props.elems[counter].word),
            ' ',
            React.createElement("button", { className: "word", color: "secondary", onClick: function () { return playaudio(getaudio(props.elems[counter].audio)); } },
                React.createElement(VolumeUpIcon, { color: "secondary", sx: { fontSize: 40, color: '#f3711a' } })),
            React.createElement("p", { className: "wordtext" }, props.elems[counter].translate),
            ' '),
        React.createElement("div", { className: "control_container" },
            React.createElement(Button, { sx: { height: 50, width: 200, fontSize: 22 }, className: "left", tabIndex: 0, variant: "contained", color: "error", key: "Wrong", onClick: function () {
                    props.updatefunc(false, props.elems[counter]);
                    if (counter === props.elems.length - 1)
                        props.endfunc();
                    else
                        setCounter(counter + 1);
                } }, "Wrong"),
            React.createElement(Button, { sx: { height: 50, width: 200, fontSize: 22 }, className: "right", variant: "contained", color: "success", key: "Right", onClick: function () {
                    props.updatefunc(true, props.elems[counter]);
                    if (counter === props.elems.length - 1)
                        props.endfunc();
                    else
                        setCounter(counter + 1);
                } },
                ' ',
                "Right"))));
}
